export const SelectSectionBiOrigin = 'section_click';

export const AUTOMATION_IDS = {
  BUTTON: 'add-section-button',
  SECTION_BOX_SELECTED: 'section-box-Selected',
  BUTTON_CONTAINER: 'add-section-button-container',
  RESIZE_HANDLE_CONTAINER: 'section-resize-handle-container',
  EMPTY_STATE: {
    CONTAINER: 'section-empty-state',
    ADD_ELEMENT: 'section-empty-state-add-element',
    ADD_SECTION: 'section-empty-state-add-section',
    ADD_SECTION_AI: 'section-empty-state-add-section-ai',
  },
};

export const enum ButtonAlignment {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
}
